var _linearGradient, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 0,
    y2: 512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2af598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009efd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m274.070312 121.785156 134.214844 134.214844-134.214844 134.214844-28.285156-28.285156 85.929688-85.929688h-227.714844v-40h227.714844l-85.929688-85.929688zm237.929688 134.214844c0 68.378906-26.628906 132.667969-74.980469 181.019531-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469s-132.667969-26.628906-181.019531-74.980469c-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531zm-40 0c0-119.101562-96.898438-216-216-216s-216 96.898438-216 216 96.898438 216 216 216 216-96.898438 216-216zm0 0",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.3076f465f4658774429178e70c3c0a71.svg";
export { ForwardRef as ReactComponent };